import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedOfferData, ITrackedOffer} from "./tracked_utils/tracked_offer";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";

export const pageviewAlgolytics = delayHit((payload: Object) => hitAlgolytics("views", payload), 500);

export const offerDetailPageview = (offer: ITrackedOffer, vendor: ITrackedVendor) => {
    const payload = {
        view_type: "offer",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer)
    };
    pageviewAlgolytics(payload);
};
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedOfferData, ITrackedOffer} from "./tracked_utils/tracked_offer";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";

export const pageviewAlgolytics = delayHit((payload: Object) => hitAlgolytics("views", payload), 500);

export const offerDetailPageview = (offer: ITrackedOffer, vendor: ITrackedVendor) => {
    const payload = {
        view_type: "offer",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer)
    };
    pageviewAlgolytics(payload);
};
